export default __webpack_public_path__ + "static/Surace-1ec48c41df51c80cdf10f0f1db3502be.jpg";